import { EyeIcon } from '@heroicons/react/24/outline'
import { LoanSubmissionDocument } from 'pages/LoanSubmission/types'
import { openS3Document } from 'services'
import { Modal, Tooltip } from 'stories/components'
import { PlainTable } from 'stories/components/PlainTable'

import { ExtractedFile } from './types'

export const ExtractDocumentFilesModal = ({
  files,
  document,
  onClose,
}: {
  files: ExtractedFile[]
  document: LoanSubmissionDocument
  onClose: Function
}) => {
  const tableHeader = ['No', 'File Name', 'Actions']

  const tableData = files.map((file, index) => [
    index + 1,
    `${file.name}.${file.ext}`,
    <Tooltip message="View File">
      <button className="btn-icon" onClick={() => openS3Document(file.fileKey, true)}>
        <EyeIcon className="w-4 h-4" />
      </button>
    </Tooltip>,
  ])

  return (
    <Modal
      title={`Extracted Files - ${document.name}`}
      titleCancel="Close"
      titleOkay=""
      isOpen
      onClose={() => onClose()}
    >
      <div>
        <p className="text-sm text-gray-600 mb-4">These files are uploaded to Document Storage.</p>
        <PlainTable header={tableHeader} data={tableData} tdClass="px-4 py-3 whitespace-nowrap" thClass="text-xs" />
      </div>
    </Modal>
  )
}
